import React from "react";
import { CustomChip } from "../../../../../components/chip/Chip";

export function getTabIndicacionSolicitudEstadoChip(estado) {
    const ESTADO_PENDIENTE = 1;
    const ESTADO_APROBADO = 2;   
    const ESTADO_NUEVO_CONTRATO = 3;
    const ESTADO_RECHAZADO = 4;  

  switch (estado) {
        case ESTADO_PENDIENTE:
            return (
                <CustomChip label='Pendiente' isYellow title='Pendiente' />
            )
        case ESTADO_APROBADO:
            return (
                <CustomChip label='Aprobado' isGreen title='Aprobado' />
            )
        case ESTADO_NUEVO_CONTRATO:
            return (
                <CustomChip label='Nuevo Contrato' isBlue title='Nuevo Contrato' />
            )
        case ESTADO_RECHAZADO:
            return (
                <CustomChip label='Rechazado' isRed title='Rechazado' />
            )
        default: return;
    }
}
